import { memo } from 'react';
import FJModelSelectorPanel from '../../../../common/components/FJModelSelectorPanel/FJModelSelectorPanel';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor';
import {
    AI_PHOTO_EDITOR_MODEL_FILTERS,
    AI_PHOTO_EDITOR_MODELS,
} from '../../../../config/dataConfig/FJAIPhotoEditorData';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJAIPhotoEditorModelSelectorContainer = memo(function FJAIPhotoEditorModelSelectorContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const curModel = useSelector(state => state.aiPhotoEditor.curModel);

    const changeModel = useCallback(
        model => {
            dispatch(FJActionAIPhotoEditor.changeModelAction(model.value));
        },
        [dispatch],
    );

    return (
        <FJModelSelectorPanel
            offsetLeft={26}
            offsetTop={-21}
            currentModelValue={curModel}
            onSelect={changeModel}
            modelList={AI_PHOTO_EDITOR_MODELS}
            filterConfig={AI_PHOTO_EDITOR_MODEL_FILTERS}
        />
    );
});

export default FJAIPhotoEditorModelSelectorContainer;
